import { useState } from 'react';
import { supabase } from '../lib/supabase';

const PD = {
  bg:     "#FAF7F2",
  bgCard: "#FFFFFF",
  text:   "#1A1A24",
  sub:    "#2C2938",
  dim:    "#5A5560",
  faint:  "#8A86A0",
  border: "#E8E5F0",
  accent: "#8B7BC2",
};

const B = { fontFamily: "'Outfit', 'Helvetica Neue', sans-serif" };

/* Shown after the user lands from a password reset email
   (AuthContext.passwordRecovery). Sets the new password on the
   recovery session, then hands control back to the app. */
export default function SetNewPassword({ onDone }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password needs at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      const { error: updateError } = await supabase.auth.updateUser({ password });
      if (updateError) throw updateError;
      onDone();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%", ...B, fontSize: 14,
    padding: "12px 16px", background: PD.bgCard,
    border: `1px solid ${PD.border}`, color: PD.text,
    outline: "none", borderRadius: 8,
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      justifyContent: "center", alignItems: "center",
      padding: "56px 24px", background: PD.bg,
    }}>
      <h2 style={{ ...B, fontSize: 22, fontWeight: 500, color: PD.text, marginBottom: 6 }}>
        Choose a new password
      </h2>
      <p style={{ ...B, fontSize: 14, color: PD.dim, marginBottom: 32 }}>
        You followed a reset link. Set your new password below.
      </p>
      <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: 380 }}>
        <div style={{ marginBottom: 20 }}>
          <label style={{ ...B, fontSize: 13, color: PD.sub, display: "block", marginBottom: 6 }}>New password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="8+ characters" required minLength={8} style={inputStyle} />
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ ...B, fontSize: 13, color: PD.sub, display: "block", marginBottom: 6 }}>Confirm password</label>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            placeholder="Same password again" required minLength={8} style={inputStyle} />
        </div>
        {error && (
          <p style={{
            ...B, fontSize: 13, color: "#E87070", marginBottom: 16,
            padding: "10px 14px", background: "#E8707015", borderRadius: 8,
            border: `1px solid #E8707030`,
          }}>
            {error}
          </p>
        )}
        <button type="submit" disabled={loading} style={{
          width: "100%", ...B, fontSize: 14, fontWeight: 600, letterSpacing: "0.04em",
          background: loading ? PD.dim : PD.text, color: PD.bg, border: "none",
          padding: "14px 24px", cursor: loading ? "default" : "pointer", borderRadius: 32,
        }}>
          {loading ? 'One moment...' : 'Save new password'}
        </button>
      </form>
    </div>
  );
}
